<template>
  <div class="main">
    <li class="tree-node">
      <div
        :class="isSelected ? 'tree-node__famille--selected' : 'tree-node__famille'"
        @click="planVenteClicked(node, 'famille')"
      >
        <span>{{ node.libelleFamille }}</span>
        <span class="tree-node__count">{{ articlesCountText(node.nbArt) }}</span>
      </div>
      <FontAwesomeIcon
        class="tree-node__button"
        :icon="opened ? 'chevron-up' : 'chevron-down'"
        @click="toggle"
      />
    </li>
    <ul
      v-show="opened"
      class="sub-node"
    >
      <PlanVenteTreeNode
        v-for="subNode of planVente"
        :key="subNode.codeFamille"
        :node="subNode"
        @planVenteClicked="forwardPlanVenteClicked"
      />
      <FontAwesomeIcon
        icon="spinner"
        size="2x"
        v-if="searchingArticles"
        spin
      />
      <li
        class="tree-node"
        v-for="article of articles"
        :key="article.codeArticle"
      >
        <div
          @click="planVenteClicked(article, 'article')"
        >
          <span>{{ article.codeArticle }} - {{ article.designation1 }}</span>
        </div>
      </li>
      <Pagination
        v-if="pagesArticles > 1"
        :current="pageArticle"
        :pages="pagesArticles"
        @change="setPage"
      />
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getPlanVente } from '../../api/planVente'
import { getArticles } from '../../api/article'
import Pagination from '../Pagination.vue'

export default {
  name: 'PlanVenteTreeNode',
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      opened: false,
      planVente: {},
      articles: {},
      pagesArticles: 1,
      pageArticle: 1,
      searchingArticles: false
    }
  },
  components: { Pagination },
  computed: {
    ...mapGetters(['selectedPlanVente', 'includeArticles', 'searchArticle']),
    isSelected() {
      return this.selectedPlanVente === this.node.codeFamille
    },
    watchedProperties() {
      return `${this.opened}|${this.includeArticles}|${this.searchArticle}|${this.pageArticle}`
    }
  },
  watch: {
    watchedProperties: async function() {
      if (this.opened && this.includeArticles) {
        this.searchingArticles = true

        let articleResponse =  await getArticles({
          queryString: this.searchArticle,
          page: this.pageArticle,
          codeFamille: this.node.codeFamille,
          familleExact: true,
          filterArticlesFields: true
        })
        if (articleResponse !== null) {
          this.articles = articleResponse.list
          this.pagesArticles = articleResponse.pages
        }

        this.searchingArticles = false
      }
    }
  },
  methods: {
    ...mapActions(['clickPlanVente']),
    articlesCountText(count) {
      if (count === 0) return null
      let text = ` - ${count} article`
      return count > 1 ? text + 's' : text
    },
    async toggle() {
      if (Object.keys(this.planVente).length === 0 && Object.keys(this.articles).length === 0) {
        this.planVente = await getPlanVente(this.node.codeFamille)
      }
      this.opened = !this.opened
    },
    planVenteClicked(element, type) {
      let code = ''
      let libelle = ''

      if (type === 'article') {
        code = element.codeArticle
        libelle = element.codeArticle + ' - ' + element.designation1
      } else { //type === 'famille'
        code = element.codeFamille
        libelle = element.libelleFamille
      }
      this.clickPlanVente(code)

      let selection = {
        code: code,
        type: type,
        libelle: libelle
      }
      this.$emit('planVenteClicked', selection)
    },
    forwardPlanVenteClicked(selection) {
      this.$emit('planVenteClicked', selection)
    },
    setPage(page) {
      this.pageArticle = page
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

span {
  user-select: none;
}

.tree-node {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tree-node__famille {
  color: #434343;
}

.tree-node__famille--selected {
  color: #000;
  font-weight: bold;
}

.tree-node__count {
  margin-left: 0.4rem;
  color: #676767;
  font-weight: bold;
}

.tree-node__button {
  margin-left: 0.4rem;
}

.sub-node {
  margin-left: 1.5rem;
  padding: 0;
}
</style>
